import { ILog } from './../../../global/types';
import { TransferCreditsProgressState } from './../../progression/transfer_credits_progress_state';
import { MemberDatasource, IMemberDatasource } from './../../../global/datasources/member_datasource';
import { IDisplayMessageService } from '../../../global/services/display_message_service';
import { College } from '../../builders/college_builder';
import { ICommand } from '../../../../vendor/core-ts-types/dist/main';
import { TransferCollegesWithCoursesQuery } from '../../queries/transfer_colleges_with_courses_query';
import { CollegeQueryResults } from '../../builders/college_query_results_builder';
import { getSearchResultsMessage } from '../../../global/strategies/search_results_strategy';

export class TransferCreditsPastCoursesController {
  headerText?: string;
  subheaderText?: string;
  searchBoxText?: string;
  description?: string;

  querySet: {
    has_more: boolean;
    result: College[];
  };

  model: {
    member: IMemberDatasource;
  };

  flags: {
    showCollegeSearch: boolean;
  };

  dropdownHeader: string = '';

  constructor(
    ngMemberDatasource: MemberDatasource,
    private log: ILog,
    private searchTransferCollegesCommand: ICommand,
    private selectTransferCollegeCommand: ICommand,
    private deselectTransferCollegeCommand: ICommand,
    private ngTransferCollegesWithCoursesQuery: TransferCollegesWithCoursesQuery,
    private ngTransferCreditsProgressState: TransferCreditsProgressState,
    private ngDisplayMessageService: IDisplayMessageService,
    private $element: ng.IAugmentedJQuery
  ) {
    this.querySet = {
      has_more: false,
      result: []
    };
    this.headerText = this.ngDisplayMessageService('colleges_header').text;
    this.subheaderText = this.ngDisplayMessageService('colleges_subheader').text;
    this.searchBoxText = this.ngDisplayMessageService('colleges_search_box').text;
    this.description = this.ngDisplayMessageService('colleges_description').text;

    this.flags = {
      showCollegeSearch: !(this.ngTransferCollegesWithCoursesQuery.result.length > 0)
    };

    this.model = {
      member: ngMemberDatasource.read()
    };
  }

  onSearchChange($event: any): void {
    this.searchTransferCollegesCommand($event.detail.value).then((collegeQueryResponse: CollegeQueryResults): void => {
      this.querySet = {
        has_more: collegeQueryResponse.has_more,
        result: collegeQueryResponse.colleges
      };

      this.dropdownHeader = getSearchResultsMessage(this.querySet);
    });
  }

  onSelectQueryItem($event: any): void {
    this.toggleShowCollegeSearch();
    this.selectTransferCollegeCommand(JSON.parse($event.detail.value)).then(() => {
      this.log.user.success({
        content: `College added`,
        timeout: 10000,
        dismissOnTimeout: true,
        dismissButton: true
      });
      this.$element.find('hi-typeahead')[0]['searchValue'] = '';
    });
  }

  onRemoveQueryItem(queryItem: College): void {
    this.deselectTransferCollegeCommand(queryItem).then(() => {
      this.resetShowCollegeSearch();
    });
  }

  toggleShowCollegeSearch(): void {
    this.flags.showCollegeSearch = !this.flags.showCollegeSearch;
  }

  resetShowCollegeSearch(): void {
    this.flags.showCollegeSearch = !(this.ngTransferCollegesWithCoursesQuery.result.length > 0);
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngTransferCreditsPastCoursesController', TransferCreditsPastCoursesController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/past_courses/past_courses.ts